<template>
  <div class="shopping-cart">
    <van-nav-bar title="购物车" fixed />
    <h1>shoppingCart</h1>
  </div>
</template>

<script>
export default {
  name: 'ShoppingCart'
}
</script>

<style>

</style>